<template>
    <div id="novel_create">
        <div class="novel_create">
            <div class="novel_create1 cursor_1" @click="toHome">
                <img src="../assets/image/icon_right.png" alt="">
                创建作品
            </div>
            <div class="novel_create2">
                <div class="novel_create2_1">
                    <!-- 核心受众 -->
                    <div class="novel_create3">
                        <div class="novel_create4">核心受众</div>
                        <div class="novel_create5" v-for="(item, i) in sex" :key="i" @click.stop="getSex(item.value)">
                            <img :src="novelInfo.sex === item.value ? iconSelect[1] : iconSelect[0]" class="cursor_1"
                                alt="">
                            {{ item.name }}
                        </div>
                    </div>
                    <div class="novel_create6"></div>

                    <!-- 作品类型 -->
                    <div class="novel_create3">
                        <div class="novel_create4"> <span>*</span>小说题材</div>
                        <div class="novel_create8">
                            <div class="novel_create8_1 cursor_1" v-if="novelInfo.typeName" @click="openLabel3">
                                {{ novelInfo.typeName }}
                                <img :src="iconSelect[4]" @click.stop="delLabel(0, '类型')" alt="">
                            </div>
                            <div v-if="!novelInfo.typeName" class="novel_create9 cursor_1" @click="openLabel3">
                                <img :src="iconSelect[3]" alt="">
                                {{ novelInfo.typeName ? '更换题材' : '添加题材' }}
                            </div>
                        </div>
                        <!-- <div class="novel_create7">
                            <el-cascader v-model="novelInfo.typeName" :options="options"
                                :props="{ expandTrigger: 'hover' }" @change="handleChange"
                                placeholder="请选择作品类型"></el-cascader>
                        </div> -->
                    </div>
                    <div class="lgText">小说题材不会选？全民作家金牌导师来帮你！<a class="cursor_80" @click.stop="lgClick">去找灵感</a></div>
                    <!-- 作品标签 -->
                    <div class="novel_create3">
                        <div class="novel_create4"> <span>*</span>小说标签</div>
                        <div class="novel_create8">
                            <div class="novel_create8_1 cursor_1" v-for="(item, i) in novelInfo.labelNames" :key="i"
                                @click="openLabel">
                                {{ item }}
                                <img :src="iconSelect[4]" @click.stop="delLabel(i, '标签')" alt="">
                            </div>
                            <div v-if="novelInfo.labelNames.length < 20" class="novel_create9 cursor_1"
                                @click="openLabel">
                                <img :src="iconSelect[3]" alt="">
                                添加标签
                            </div>
                        </div>
                    </div>

                    <!-- 文笔风格 -->
                    <div class="novel_create3">
                        <div class="novel_create4"> <span>*</span>文笔风格</div>
                        <div class="novel_create8">
                            <div class="novel_create8_1 cursor_1" v-for="(item, i) in novelInfo.style" :key="i"
                                @click="openLabel2">
                                {{ item }}
                                <img :src="iconSelect[4]" @click.stop="delLabel(i, '风格')" alt="">
                            </div>
                            <div v-if="novelInfo.style.length < 10" class="novel_create9 cursor_1" @click="openLabel2">
                                <img :src="iconSelect[3]" alt="">
                                添加标签
                            </div>
                        </div>
                    </div>
                    <!-- 写作视角 -->
                    <div class="novel_create3">
                        <div class="novel_create4"> <span>*</span>写作视角</div>
                        <div class="novel_create5 cursor_1" v-for="(item, i) in viewList" @click="getview(item)"
                            :key="i">
                            <img :src="novelInfo.view === item ? iconSelect[2] : iconSelect[0]" alt="">
                            {{ item }}
                        </div>
                    </div>
                    <div class="novel_create6"></div>

                    <!-- 篇幅设定 -->
                    <!-- <div class="novel_create3">
                        <div class="novel_create4"> <span>*</span>篇幅设定</div>
                        <div class="novel_create5 cursor_1" v-for="(item, i) in lengthList" @click="getLength(item)">
                            <img :src="novelInfo.length.includes(item) ? iconSelect[2] : iconSelect[0]" alt="">
                            {{ item }}
                        </div>
                    </div> -->
                    <div class="novel_create6"></div>
                    <!-- 总章节数 -->
                    <div class="novel_create3" v-if="novelInfo.length.includes('长篇')">
                        <div class="novel_create4"> <span>*</span>总章节数</div>
                        <div class="create_novel7">
                            <el-input v-model="novelInfo.maxChapter" type="number"
                                :placeholder="'章节数小于' + maxChapterLen"></el-input>
                        </div>
                    </div>
                    <div class="novel_create6"></div>
                    <!-- 首次生成章节 -->
                    <div class="novel_create3">
                        <div class="novel_create4" v-if="novelInfo.length.includes('长篇')"> <span>*</span>首次生成章节</div>
                        <div class="novel_create4" v-else> <span>*</span>生成章节</div>
                        <div class="create_novel7">
                            <el-input v-model="novelInfo.chaptersNumber" type="number"
                                :placeholder="novelInfo.length.includes('长篇') ? `请输入生成章节1~${chaptersNumberLen}` : `请输入生成章节1~${shortStoryLen}`"></el-input>
                            <div class="create_novel11" v-if="novelInfo.length.includes('长篇')">{{ chapterText }}</div>
                            <div class="create_novel11" v-else>{{ chapterText1 }}</div>

                        </div>
                    </div>
                    <!-- 长记忆功能 -->
                    <div class="novel_create3">
                        <div class="novel_create4"> <span>*</span>长记忆</div>
                        <div class="flex-row">
                            <div class="flex-row t-m-r-10">
                                <!-- <svg-icon iconClass="vip" class="custom" style="font-size: 22px;color: #FF8802;" /> -->
                                <img src="@/assets/image/vip/icon6.png" width="21" height="19" />
                                <span class="t-m-l-2">专业会员专享</span>
                            </div>
                            <el-switch @change="cjyChange" v-model="novelInfo.recall"></el-switch>
                        </div>
                    </div>
                    <div class="novel_create3">
                        <div class="novel_create4">&nbsp;</div>
                        <div class="create_novel7">
                            <div class="create_novel11" v-html="chapterText2"></div>
                        </div>
                    </div>
                    <div class="novel_create6"></div>
                    <!-- 世界观 -->
                    <div class="novel_create3">
                        <div class="novel_create4">世界观<span>(非必填)</span></div>
                        <div class="create_novel7 create_novel30">
                            <el-input v-model="novelInfo.world" @input="insertTextCaChe" type="textarea" ref="world"
                                :autosize="{ minRows: 3, maxRows: 8 }" :maxlength="5000" show-word-limit
                                placeholder="请输入世界观设定"></el-input>
                            <!-- 停止生成按钮 -->
                            <AIStopCreate :hide="streamStatus" plain bottom="10px" emit @stop="stop"
                                v-if="streamStatus && requireIndex === 3"></AIStopCreate>
                        </div>
                        <div class="create_novel16 cursor_1 AIicon" @click="openPopup('世界观', 3)"></div>
                        <div class="loading_text_create" v-if="streamStatus && requireIndex === 3">
                            <img src="../assets/image/loading.png" alt="">
                        </div>
                    </div>
                    <div class="novel_create6"></div>
                    <div class="novel_create3">
                        <div class="novel_create4"></div>
                        <div class="create_novel7 create_novel30 t-m-b-10 cursor_80">
                            <a style=" text-decoration: underline;color: #FF8802;" @click="openLabel5">常见金手指推荐</a>
                        </div>
                    </div>
                    <!-- 金手指 -->
                    <div class="novel_create3">
                        <div class="novel_create4">金手指<span>(非必填)</span></div>
                        <div class="create_novel7 create_novel30">
                            <el-input v-model="novelInfo.goldfinger" @input="insertTextCaChe" ref="goldfinger"
                                :autosize="{ minRows: 3, maxRows: 8 }" :maxlength="5000" show-word-limit type="textarea"
                                placeholder="请输入金手指设定"></el-input>
                            <!-- 停止生成按钮 -->
                            <AIStopCreate :hide="streamStatus" plain bottom="10px" emit @stop="stop"
                                v-if="streamStatus && requireIndex === 4"></AIStopCreate>
                        </div>
                        <div class="create_novel16 cursor_1 AIicon" @click="openPopup('金手指', 4)"></div>
                        <div class="loading_text_create" v-if="streamStatus && requireIndex === 4">
                            <img src="../assets/image/loading.png" alt="">
                        </div>
                    </div>
                    <div class="novel_create6"></div>
                    <!-- 主线剧情 -->
                    <div class="novel_create3">
                        <div class="novel_create4"><span>*</span>主线剧情</div>
                        <div class="create_novel7 create_novel30">
                            <el-input v-model="novelInfo.plot" ref="nzxjq" @input="insertTextCaChe"
                                :autosize="{ minRows: 3, maxRows: 8 }" :maxlength="20000" show-word-limit
                                type="textarea" placeholder="请输入主线剧情"></el-input>
                            <!-- 停止生成按钮 -->
                            <AIStopCreate :hide="streamStatus" plain bottom="10px" emit @stop="stop"
                                v-if="streamStatus && requireIndex === 5"></AIStopCreate>
                        </div>
                        <div class="create_novel16 cursor_1 AIicon" @click="openPopup('主线剧情', 5)"></div>
                        <div class="loading_text_create" v-if="streamStatus && requireIndex === 5">
                            <img src="../assets/image/loading.png" alt="">
                        </div>
                    </div>
                    <div class="novel_create6"></div>
                    <!-- 角色信息 -->
                    <div class="novel_create3">
                        <div class="novel_create4"> <span>*</span>角色信息</div>
                        <div class="create_novel7 create_novel30">
                            <el-input v-model="novelInfo.protagonistNames" @input="insertTextCaChe" ref="nxsjsm"
                                type="textarea" :autosize="{ minRows: 3, maxRows: 8 }" :maxlength="10000"
                                show-word-limit placeholder="请输入角色名字、性格、外貌特征"></el-input>
                            <!-- 停止生成按钮 -->
                            <AIStopCreate :hide="streamStatus" plain bottom="10px" emit @stop="stop"
                                v-if="streamStatus && requireIndex === 1"></AIStopCreate>
                        </div>
                        <div class="create_novel16 cursor_1 AIicon" @click="openPopup('角色信息', 1)"></div>
                        <div class="loading_text_create" v-if="streamStatus && requireIndex === 1">
                            <img src="../assets/image/loading.png" alt="">
                        </div>
                    </div>
                    <div class="novel_create6"></div>

                    <!-- 作品简介 -->
                    <div class="novel_create3">
                        <div class="novel_create4"> <span>*</span>作品简介</div>
                        <div class="create_novel7 create_novel30">
                            <el-input v-model="novelInfo.introduction" @input="insertTextCaChe" ref="nxsjj"
                                type="textarea" :autosize="{ minRows: 3, maxRows: 8 }" :maxlength="3000" show-word-limit
                                placeholder="请输入作品简介"></el-input>
                            <!-- 停止生成按钮 -->
                            <AIStopCreate :hide="streamStatus" plain bottom="10px" emit @stop="stop"
                                v-if="streamStatus && requireIndex === 2"></AIStopCreate>
                        </div>
                        <div class="create_novel16 cursor_1 AIicon" @click="openPopup('作品简介', 2)"></div>
                        <div class="loading_text_create" v-if="streamStatus && requireIndex === 2">
                            <img src="../assets/image/loading.png" alt="">
                        </div>
                    </div>
                    <div class="novel_create6"></div>

                    <!-- 作品名称 -->
                    <div class="novel_create3">
                        <div class="novel_create4"> <span>*</span>作品名称</div>
                        <div class="create_novel7 create_novel30">
                            <el-input v-model="novelInfo.novelName" @input="insertTextCaChe" ref="nxszpm"
                                :maxlength="150" show-word-limit placeholder="请输入作品名称"></el-input>
                        </div>
                        <div class="create_novel16 cursor_1 AIicon" @click="openPopup('作品名称', 0)"></div>
                        <div class="loading_text_create" v-if="streamStatus && requireIndex === 0">
                            <img src="../assets/image/loading.png" alt="">
                        </div>
                    </div>
                    <div class="novel_create6"></div>

                    <!-- 作品要求 -->
                    <div class="novel_create3">
                        <div class="novel_create4">作品要求<span>(非必填)</span></div>
                        <div class="create_novel7">
                            <el-input v-model="novelInfo.requirement" @input="insertTextCaChe" type="textarea"
                                :autosize="{ minRows: 3, maxRows: 8 }" :maxlength="5000" show-word-limit
                                placeholder="请输入您对作品的其他要求，例如:您偏爱的写作风格、独特的世界观、巧妙的伏笔、跌宕起伏的情节，以及想要探讨的主题深度等"></el-input>
                            <div class="create_novel12">严禁上传任何抄袭、涉黄、涉赌、涉毒、涉政、涉黑等违规内容。一经查实，全书屏蔽整改并取消福利，情节严重的会追究其法律责任。
                            </div>
                        </div>
                    </div>
                    <div class="novel_create6"></div>

                    <div class="novel_create3">
                        <div class="novel_create4"></div>
                        <div class="create_novel17">
                            <div class="create_novel20">
                                <el-button :loading="loading" type="warning"
                                    class="create_novel14 create_novel15 cursor_1" @click="createNovel">
                                    {{ loading ? '正在创建...' : '确认创建' }}
                                </el-button>
                            </div>

                        </div>

                    </div>
                </div>

            </div>
        </div>
        <createHelp ref="createHelp" @getRequire="getRequire" />
        <createLabel title="小说标签" ref="createLabel" @getLable="getLable" />
        <createLabel2 ref="createLabel2" @getLable="getLable2" />
        <createLabel3 title="小说题材" ref="createLabel3" @getLable="getLable3" />
        <createLabel5 title="选择金手指" ref="createLabel5" @getLable="getLable5" />
        <delPpopup ref="delPopup" @confirm="confirm"></delPpopup>
    </div>
</template>

<script>
import data from '@/assets/data';
import createHelp from './novel_create_help.vue';
import createLabel from './novel_create_label.vue';
import createLabel2 from './novel_create_label2.vue';
import createLabel3 from './novel_create_label3.vue';
import createLabel5 from './novel_create_label5.vue';
import api from '@/api/api';
import delPpopup from './del_popup.vue';
import _ from 'lodash'
import { EventBus } from '@/utils/eventBus';
export default {
    components: {
        createHelp, createLabel, delPpopup, createLabel2, createLabel3, createLabel5
    },
    data() {
        return {
            iconSelect: data.iconSelect,//选择图标
            sex: data.sex, //性别选择
            //创建小说表单
            novelInfo: {
                sex: "男频",//核心受众
                typeName: '',//作品类型
                labelNames: [],//作品标签
                style: [], //文笔风格,接口是string类型，提交的时候进行转换就行了，使用数据更适合处理业务逻辑
                view: '第三人称',//写作视角
                recall: false,//长记忆
                length: '中长篇小说',//篇幅设定
                maxChapter: '',//总章节数
                chaptersNumber: '',//首次生成章节
                world: '',//世界观
                goldfinger: '',//金手指
                plot: '',//主线剧情
                protagonistNames: '',// 角色信息
                outlineSetting: '无',//大纲初步设定
                novelName: '',//作品名称
                introduction: '',//作品简介
                requirement: '',//作品要求
            },
            //必填项字段,移除单选按钮这些，进行验证
            verify: ['typeName', 'labelNames', 'style', 'maxChapter', 'chaptersNumber', 'plot', 'protagonistNames','introduction', 'novelName'],
            options: [], //类型
            viewList: ['第一人称', '第三人称'],//写作视角集合
            lengthList: ['中长篇小说', '短篇小说'],//篇幅设定列表
            resultText: ['选择“完整结局”,最后一章将为小说提供一个明确的结局', '选择“开放结局”,故事将保留伏笔,便于后续续写或连载'],
            requireIndex: null, //帮写要求 0作品名称 1角色信息 2作品简介
            chapterText: '支持百万字小说连载:作品首次创建时支持一次性生成最多50章节，生成完成后，用户可在现有框架下无限续写章节。',
            chapterText1: `短篇小说最多支持一次性生成50章，后期也支持 无限续写章节。`,
            chapterText2: `需手动启动才能开启超长记忆功能。<br/>注:开启后，后续功能会产生记忆时长，需耐心等待~`,
            createBtn: false, //判断填写完成
            streamStatus: false, //流式请求
            streamIndex: 0, //流式请求下标
            streamLast: false,//流式请求最后一条
            debounceTimer: null, //防抖定时器
            typingTimer: null, // 打字效果定时器
            maxChapterLen: 200,
            chaptersNumberLen: 50,//长篇小说首次生成章节200
            shortStoryLen: 50,//短篇小说首次生成章节50
            refType: null,//滚动ref对象
            loading: false,//加载
            cacheKey: '_novel_add',
            helpPlot: '',//主线剧情到帮写里面
            helpGoldfinger: '',//选项金手指到帮写
        }
    },
    beforeDestroy() {
        this.clearTime()
    },
    created() {
        this.getUserLoginState(false)
    },
    // watch: {
    //     'novelInfo': {
    //         handler(newVal) {
    //             if (newVal) {
    //                 localStorage.setItem(this.novelInfo.length + this.cacheKey, JSON.stringify(newVal))
    //             }
    //         },
    //         deep:true
    //     }
    // },
    methods: {
        //@input 事件
        insertTextCaChe() {
            localStorage.setItem(this.novelInfo.length + this.cacheKey, JSON.stringify(this.novelInfo))
        },
        getCache(length) {
            this.$set(this.novelInfo, 'length', length)
            console.log('读取缓存=', this.novelInfo)
            let novel = JSON.parse(localStorage.getItem(this.novelInfo.length + this.cacheKey))
            console.log(novel)
            if (novel && Object.keys(novel).length > 0) {
                this.$confirm('是否填写数据', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.novelInfo = novel
                }).catch(() => {
                    localStorage.removeItem(this.novelInfo.length + this.cacheKey)
                });
            }
        },
        //从外面调用初始化数据
        getNovelInit(length, item) {
            if (Object.keys(item).length > 0) {
                this.$set(this.novelInfo, 'length', length)
                localStorage.removeItem(this.novelInfo.length + this.cacheKey)
                console.log('item=', item)
                this.novelInfo.novelName = item.novelName
                this.novelInfo.typeName = item.typeName
                this.novelInfo.labelNames = item.labelNames ? [item.labelNames] : []
                this.novelInfo.style = item.style ? [item.style] : []
                this.novelInfo.world = item.world
                this.novelInfo.goldfinger = item.goldfinger
                // this.novelInfo.plot = item.plot
                this.helpPlot = item.plot
                console.log('赋值后的数据=', this.novelInfo)
            }
        },
        getStyle() {
            api.getParameter('pcxscs', 'style').then((res) => {
                if (res.code == 200) {
                    res.data[0].children.forEach(item => {
                        let children = item.placeholder.split(',');
                        let childrenArray = children.map(child => ({ value: child, label: child }));
                        this.options.push({
                            value: item.paramName,
                            label: item.paramName,
                            children: childrenArray
                        });
                    });
                }
            })
        },
        toHome() {
            if (this.hasValues()) {
                this.$refs.delPopup.openPrompt(3)
            } else {
                this.$emit('toList')
                // this.$router.replace({ path: '/novel' });
            }
        },
        hasValues() {
            for (const key in this.novelInfo) {
                if (this.verify.includes(key)) {
                    const value = this.novelInfo[key];
                    // 检查数组类型（非空数组才视为有值）
                    if (Array.isArray(value)) {
                        if (value.length > 0) return true;
                        continue; // 空数组不算有值，继续检查其他字段
                    }
                    // 检查字符串类型（非空字符串才视为有值）
                    if (typeof value === 'string') {
                        if (value.trim() !== '') return true;
                        continue;
                    }
                    // 检查数字类型（0也算有效值）
                    if (typeof value === 'number') {
                        return true;
                    }
                    // 检查布尔值（false也算有效值）
                    if (typeof value === 'boolean') {
                        return true;
                    }
                    // 检查对象类型（非空对象才视为有值）
                    if (typeof value === 'object' && value !== null) {
                        if (Object.keys(value).length > 0) return true;
                        continue;
                    }
                }
            }
            return false;
        },
        confirm() {

            this.$router.push({ path: '/' });
        },
        // 作品类型
        handleChange(value) {
            this.novelInfo.typeName = value[1]
            // this.empty()
        },
        // 核心受众
        getSex(value) {
            if (this.novelInfo.sex === value) return
            this.novelInfo.sex = value
        },
        //写作视角切换
        getview(name) {
            if (this.novelInfo.view === name) return
            this.novelInfo.view = name
        },
        //篇幅设定切换
        getLength(value) {
            if (this.novelInfo.length === value) return
            this.novelInfo.length = value
            // this.empty()
        },
        // 选择标签
        openLabel() {
            this.$refs.createLabel.openLable(this.novelInfo.labelNames);
        },
        // 选择文笔风格标签
        openLabel2() {
            this.$refs.createLabel2.openLable(this.novelInfo.style);
        },
        // 选择文笔风格标签
        openLabel3() {
            this.$refs.createLabel3.openLable(this.novelInfo.typeName);
        },
        // 选择文笔风格标签
        openLabel5() {
            this.$refs.createLabel5.openLable();
        },
        // 获取标签
        getLable(i) {
            this.novelInfo.labelNames = i
            // this.empty()
        },
        // 获取文笔风格
        getLable2(i) {
            this.novelInfo.style = i
            // this.empty()
        },
        // 获取作品类型
        getLable3(i) {
            this.novelInfo.typeName = i
        },
        //选择金手指
        getLable5(content) {
            // this.novelInfo.goldfinger = content
            this.helpGoldfinger = content
        },
        // 删除标签
        delLabel(i, type) {
            this.$confirm('是否删除标签？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                if (type === '标签') {
                    this.novelInfo.labelNames.splice(i, 1)
                } else if (type === '风格') {
                    this.novelInfo.style.splice(i, 1)
                } else if (type === '类型') {
                    this.novelInfo.typeName = ''
                }
                // this.empty();
                this.$message({
                    type: 'success',
                    message: '删除成功!'
                });
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        },
        //验证必填字段
        checking() {
            if (this.novelInfo.length.includes('短篇')) {
                let i = this.verify.indexOf('maxChapter')
                if (i != -1) {
                    this.verify.splice(i, 1)
                }
            } else if (this.novelInfo.length.includes('长篇')) {
                if (!this.verify.includes('maxChapter')) {
                    this.verify.push('maxChapter')
                }
            }
            // console.log('this.verify=', this.verify)
            return Object.keys(this.novelInfo).some(key => {
                if (this.verify.includes(key)) {
                    const value = this.novelInfo[key];

                    // 检查数组类型（非空数组才视为有值）
                    if (Array.isArray(value)) {
                        if (!value.length) {
                            return true
                        }
                    }

                    // 检查字符串类型（非空字符串才视为有值）
                    if (typeof value === 'string') {
                        if (value.trim() === '') {
                            return true
                        }
                    }
                    // 检查对象类型（非空对象才视为有值）
                    if (typeof value === 'object' && value !== null) {
                        if (!Object.keys(value).length) {
                            return true
                        }
                    }
                }
                return false
            })
        },
        // 检测是否填写完成
        empty() {
            if (this.checking()) {
                this.createBtn = false
            } else {
                this.createBtn = true
            }
        },
        /**
         * @description
         * 点击AI帮写的逻辑
         * 必须几个：性别，作品类型，作品标签、文笔风格
         * 世界观--》需要必须几个 i索引 3
         * 金手指--》需要必须几个 i索引 4
         * 主线剧情 --》需要必须几个，总章节数、首次生成章节  i索引 5
         * 大纲初步设定 --》需要必须几个，主线剧情,角色信息  i索引6
         * 角色信息 --》需要必须几个，主线剧情 i索引 1
         * 作品名称 --》需要必须几个，主线剧情、角色信息 i索引 0
         * 作品简介 --》需要必须几个，主线剧情、作品名称 i索引 2
         */
        validateForm(i) {
            const validationRules = [
                {
                    condition: () => this.novelInfo.typeName === '',
                    message: '请选择小说题材！'
                },
                {
                    condition: () => this.novelInfo.labelNames.length === 0,
                    message: '请选择小说标签！'
                },
                {
                    condition: () => this.novelInfo.style.length === 0,
                    message: '请选择文笔风格！'
                },
                {
                    condition: () => [1, 2, 3, 4, 5].includes(i) && this.novelInfo.length.includes('长篇') && !Number(this.novelInfo.maxChapter),
                    message: '请输入总章节数！'
                },
                {
                    condition: () => {
                        if ([1, 2, 3, 4, 5].includes(i) && this.novelInfo.length.includes('长篇') && Number(this.novelInfo.maxChapter) && Number(this.novelInfo.maxChapter) > this.maxChapterLen) {
                            this.novelInfo.maxChapter = this.maxChapterLen
                            return true
                        }
                        return false
                    },
                    message: `总章节数超过${this.maxChapterLen}，已同步短篇最高章节数`
                },
                {
                    condition: () => [1, 2, 3, 4, 5].includes(i) && !Number(this.novelInfo.chaptersNumber),
                    message: '请输入首次生成章节数！'
                },
                {
                    condition: () => {
                        if ([1, 2, 3, 4, 5].includes(i) && this.novelInfo.length.includes('短篇') && this.novelInfo.chaptersNumber && Number(this.novelInfo.chaptersNumber) > this.shortStoryLen) {
                            this.novelInfo.chaptersNumber = this.shortStoryLen
                            return true
                        }
                        return false
                    },
                    message: `短篇生成章节超过${this.shortStoryLen}，已同步短篇最高章节数`
                },
                {
                    condition: () => {
                        if ([1, 2, 3, 4, 5].includes(i) && this.novelInfo.length.includes('长篇') && this.novelInfo.chaptersNumber && Number(this.novelInfo.chaptersNumber) > Number(this.chaptersNumberLen)) {
                            this.novelInfo.chaptersNumber = this.chaptersNumberLen
                            return true
                        }
                        return false
                    },
                    message: `中篇首次生成章节超过${this.chaptersNumberLen}，已同步首次生成最高章节数`
                },
                {
                    condition: () => {
                        if ([1, 2, 3, 4, 5].includes(i) && this.novelInfo.length.includes('长篇') && this.novelInfo.chaptersNumber && Number(this.novelInfo.chaptersNumber) > Number(this.novelInfo.maxChapter)) {
                            this.novelInfo.maxChapter = this.novelInfo.chaptersNumber
                            return true
                        }
                        return false
                    },
                    message: `中篇首次生成章节数不能超过总章节数，已同步首次生成最高章节数`
                },
                {
                    //主线剧情
                    condition: () => [0, 1, 2, 6].includes(i) && !this.novelInfo.plot.trim(),
                    message: '请填写主线剧情'
                },
                {
                    //角色信息
                    condition: () => [0,2, 6].includes(i) && !this.novelInfo.protagonistNames.trim(),
                    message: '请填写角色信息'
                },
                {
                    //作品名称
                    condition: () => i == 0 && !this.novelInfo.introduction.trim(),
                    message: '请填写作品简介'
                },
                {
                    condition: () => this.streamStatus,
                    message: '请等待AI生成结束！'
                }
            ];

            for (const rule of validationRules) {
                if (rule.condition()) {
                    this.$message({
                        message: rule.message,
                        type: 'warning'
                    });
                    return false;
                }
            }
            return true;
        },
        //帮写提示
        openPopup(title, i) {
            if (this.showLoginPage()) return
            if (!this.validateForm(i)) {
                return;
            }
            this.requireIndex = i
            let content = ''
            if (title.includes('金手指')) {
                content = this.helpGoldfinger
            } else if (title.includes('主线')) {
                content = this.helpPlot
            }

            this.$refs.createHelp.open(title, content);
        },
        //帮写提示词
        getRequire(item) {
            const baseParams = {
                ...this.novelInfo,
                content:this.novelInfo.introduction,
                menAndWomen: this.novelInfo.sex,//性别
                style: this.novelInfo.typeName,//作品类型
                label: this.novelInfo.labelNames.join(','),//作品标签
                wstyle: this.novelInfo.style.join(','),//文笔风格
                // view: this.novelInfo.view,//写作视角
                // length: this.novelInfo.length,//篇幅设定
                maxChapter: this.novelInfo.length.includes('短篇') ? this.novelInfo.chaptersNumber : this.novelInfo.maxChapter,//总章节数
                // chaptersNumber: this.novelInfo.chaptersNumber,//首次生成章节
                platform: 1,//平台
                requirement: item //弹窗填写的内容
            };
            //帮写要求 0作品名称 1角色信息 2作品简介 3世界观 4金手指 5主线剧情
            if (this.requireIndex == 0) {
                this.novelInfo.novelName = ''
                this.getStream('nxszpm', this.novelInfo.length.includes('短') ? 'short_name' : 'medium_name', baseParams);
            } else if (this.requireIndex == 1) {
                this.novelInfo.protagonistNames = ''
                this.getStream('nxsjsm', this.novelInfo.length.includes('短') ? 'short_role' : 'medium_role', baseParams);
            } else if (this.requireIndex == 2) {
                this.novelInfo.introduction = ''
                this.getStream('nxsjj', this.novelInfo.length.includes('短') ? 'short_introduction' : 'medium_introduction', baseParams);
            } else if (this.requireIndex == 3) {
                this.novelInfo.world = ''
                this.getStream('world', this.novelInfo.length.includes('短') ? 'short_world' : 'medium_world', baseParams);
            } else if (this.requireIndex == 4) {
                this.novelInfo.goldfinger = ''
                this.getStream('goldfinger', this.novelInfo.length.includes('短') ? 'short_goldfinger' : 'medium_goldfinger', baseParams);
            } else if (this.requireIndex == 5) {
                this.novelInfo.plot = ''
                this.getStream('nzxjq', this.novelInfo.length.includes('短') ? 'short_plot' : 'medium_plot', baseParams);
            } else if (this.requireIndex == 6) {
                this.novelInfo.outlineSetting = ''
                this.getStream('outline_setting', baseParams);
            }
        },
        getStream(type, aiType, params) {
            this.AIWrite({
                length: '中',
                haveId: false,
                type: aiType,
                params: params,
                success: (res) => {
                    this.streamIndex = 0
                    this.streamStatus = true
                    this.refType = type
                    localStorage.setItem('AICreateId', res.data)
                    this.getStreamContent(res.data)
                }
            })
            // api.novelHelpWrite(aiType, params).then((res) => {
            //     if (res.code === 200) {
            //         this.streamStatus = true
            //         this.refType = type
            //         localStorage.setItem('AICreateId', res.data)
            //         this.getStreamContent(res.data)
            //     } else {
            //         this.$message.warning(res.msg)
            //     }
            // })
        },
        //销毁定时器
        clearTime() {
            clearTimeout(this.debounceTimer);
            clearInterval(this.typingTimer);
            this.streamStatus = false
            this.streamLast = false
            this.streamIndex = 0
            this.refType = null
        },
        getStreamContent(id) {
            // 清除之前的定时器
            if (this.debounceTimer) {
                clearTimeout(this.debounceTimer);
            }
            this.debounceTimer = setTimeout(() => {
                api.getStreamContent(id, this.streamIndex).then((res) => {
                    if (res.code === 200) {
                        if (res.data.length !== 0) {
                            this.streamIndex = this.streamIndex + res.data.length;
                            let combinedText = '';
                            res.data.map((item) => {
                                if (item !== '[DONE]') {
                                    combinedText += item;
                                }
                            });
                            this.typeText(combinedText, () => {
                                if (res.data[res.data.length - 1] === '[DONE]') {
                                    this.streamIndex = 0;
                                    this.streamLast = true
                                }
                                if (this.streamLast) {
                                    this.streamStatus = false;
                                    this.streamLast = false;
                                    this.refType = null
                                    this.$message.success('AI生成完成！');
                                    this.insertTextCaChe()
                                    //刷新用户信息-基础会员字符刷新
                                    this.getUserInfo()
                                    // this.empty()
                                } else {
                                    this.getStreamContent(id);
                                }
                            });
                        } else {
                            this.getStreamContent(id);
                        }
                    } else {
                        this.$message.warning(res.msg)
                        this.clearTime()
                    }
                }).catch(() => {
                    this.refType = null
                });
            }, 500);
        },
        // 打字效果
        typeText(text, callback) {
            let index = 0;
            if (this.typingTimer) {
                clearInterval(this.typingTimer);
            }
            this.typingTimer = setInterval(() => {
                if (index < text.length) {
                    if (this.requireIndex == 0) {
                        this.novelInfo.novelName += text[index]
                    } else if (this.requireIndex == 1) {
                        this.novelInfo.protagonistNames += text[index]
                    } else if (this.requireIndex == 2) {
                        this.novelInfo.introduction += text[index]
                    } else if (this.requireIndex == 3) {
                        this.novelInfo.world += text[index]
                    } else if (this.requireIndex == 4) {
                        this.novelInfo.goldfinger += text[index]
                    } else if (this.requireIndex == 5) {
                        this.novelInfo.plot += text[index]
                    } else if (this.requireIndex == 6) {
                        this.novelInfo.outlineSetting += text[index]
                    }
                    index++;
                    this.$nextTick(() => {
                        const textarea = this.$refs[this.refType].$el.querySelector('textarea');
                        if (textarea) {
                            // 滚动到底部
                            textarea.scrollTop = textarea.scrollHeight;
                        }
                    });
                } else {
                    clearInterval(this.typingTimer);
                    if (callback) {
                        callback();
                    }
                }
            }, 20);
        },
        //创建小说事件
        createNovel() {
            if (this.showLoginPage()) return
            if (this.streamStatus) {
                this.$message({
                    message: '请等待AI生成结束！',
                    type: 'warning'
                });
                return
            }
            let item = _.cloneDeep(this.novelInfo);
            item.labelNames = item.labelNames.join(',')
            item.style = item.style.join(',')
            if (!item.typeName) {
                this.$message.warning(`请选择小说题材`);
                return
            }
            if (!item.labelNames) {
                this.$message.warning(`请选择小说标签`);
                return
            }
            if (!item.style) {
                this.$message.warning(`请选择文笔风格`);
                return
            }
            if (!item.maxChapter && item.length.includes('长篇')) {
                this.$message.warning(`请输入总章节数`);
                return
            }
            if (!item.chaptersNumber) {
                this.$message.warning(item.length.includes('长篇') ? `请输入首次生成章节数` : `请输入生成章节数`);
                return
            }
            if (item.length.includes('长篇') && Number(item.maxChapter) > this.maxChapterLen) {
                this.$message.warning(`总章节数超过${this.maxChapterLen}，，已同步最高章节数`);
                this.novelInfo.maxChapter = this.maxChapterLen
                return
            }
            if (item.length.includes('短篇') && Number(item.chaptersNumber) > this.shortStoryLen) {
                this.$message.warning(`短篇生成章节超过${this.shortStoryLen}，已同步短篇最高章节数`);
                this.novelInfo.chaptersNumber = this.shortStoryLen
                return
            }
            if (item.length.includes('长篇') && Number(item.chaptersNumber) > Number(this.chaptersNumberLen)) {
                this.$message.warning(`中篇首次生成章节超过${this.chaptersNumberLen}，已同步首次生成最高章节数`);
                this.novelInfo.chaptersNumber = this.chaptersNumberLen
                return
            }
            if (item.length.includes('长篇') && Number(item.chaptersNumber) > Number(item.maxChapter)) {
                this.$message.warning(`中篇首次生成章节数不能超过总章节数，已同步首次生成最高章节数`);
                this.novelInfo.maxChapter = this.novelInfo.chaptersNumber
                return
            }
            if (!item.plot) {
                this.$message.warning(`请输入主线剧情`);
                return
            }
            if (!item.protagonistNames) {
                this.$message.warning(`请输入角色信息`);
                return
            }
            // if (item.length.includes('长篇') && !item.outlineSetting) {
            //     this.$message.warning(`请输入大纲初步设定`);
            //     return
            // }
             if (!item.introduction) {
                this.$message.warning(`请输入作品简介`);
                return
            }
            if (!item.novelName) {
                this.$message.warning(`请输入作品名称`);
                return
            }
            if (item.length.includes('短篇')) {
                item.maxChapter = item.chaptersNumber
            }
            // console.log('最后提交的内容=', item);
            this.loading = true
            api.createNovel(item).then((res) => {
                if (res.code === 200) {
                    localStorage.removeItem(this.novelInfo.length + this.cacheKey)
                    this.$emit('createSuccess', res.data)
                } else {
                    this.$message.warning(res.msg)
                }
            }).finally(() => {
                this.loading = false
            })
        },
        //停止生成
        stop(name, index) {
            this.$message.success('AI已停止生成！')
            this.clearTime()
            this.insertTextCaChe()
            this.getUserInfo()
            // setTimeout(() => {
            //     this.empty()
            // }, 500);
        },
        cjyChange(e) {
            if (!this.zsVip()) {
                this.novelInfo.recall = false
                this.$confirm('超长记忆功能，仅专业会员特享，立即去开通？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    EventBus.$emit('openVip')
                }).catch(() => {

                });
            }
        },
        lgClick() {
            window.open('/hottc')
            // this.$router.push('/hottc')
        },

    }
}
</script>

<style>
#novel_create {
    width: 100%;
    height: 100%;
    background-color: #FFFFFF;
    box-shadow: 0px 0 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 10px;
}

.novel_create {
    padding: 35px 30px;
    height: 100%;
}

.AIicon:hover {
    opacity: 1 !important;
}

.novel_create3 .el-textarea .el-input__count,
.novel_create3 .el-input .el-input__count .el-input__count-inner {
    background: transparent;
}

.novel_create1 {
    font-weight: bold;
    font-size: 19px;
    color: #111111;
    display: flex;
    align-items: center;
}

.novel_create1 img {
    width: 23px;
    height: 23px;
    margin-right: 5px;
}

.novel_create2 {
    width: 100%;
    height: calc(100% - 50px);
    overflow-y: auto;
    -ms-overflow-style: none;
    scrollbar-width: none;
    margin: 0 auto;
    margin-top: 30px;
    padding-right: 60px;

}

.novel_create2_1 {
    width: 730px;
    margin: 0 auto;
}

.novel_create3 {
    display: flex;
    align-items: start;
    position: relative;
}

.novel_create4 {
    min-width: 150px;
    margin-right: 20px;
    font-size: 16px;
    color: #444444;
    text-align: right;
}

.novel_create4 span {
    color: #FF3030;
}

.novel_create5 {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #666666;
    margin-right: 40px;
}

.novel_create5 img {
    width: 18px;
    height: 18px;
    margin-right: 10px;
}

.novel_create6 {
    padding-left: 95px;
    font-size: 13px;
    color: #888888;
    margin-top: 10px;
    margin-bottom: 20px;
}

.novel_create6_1 {
    margin-bottom: 10px;
}

.el-input--suffix .el-input__inner {
    width: 625px;
    background-color: #F6F6F6;
}

.create_novel31 {
    position: relative;
}

.create_novel7 .el-input__inner,
.create_novel7 .el-textarea__inner {
    width: 625px;
    background-color: #F6F6F6;
    font-size: 15px;
    color: #666666;
    resize: none;
}

.el-input--suffix .el-input__inner::-webkit-input-placeholder,
.create_novel7 .el-input__inner::-webkit-input-placeholder,
.create_novel7 .el-textarea__inner::-webkit-input-placeholder {
    color: #777777;
    font-weight: 400;
    font-size: 15px !important;
    letter-spacing: 0;
}

/* .create_novel7 .el-textarea__inner::-webkit-scrollbar {
    display: none;
} */
/* input number类型取消增减箭头*/
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
    -webkit-appearance: none;
}

.novel_create8 {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}

.novel_create8_1 {
    background: var(--tech-btn-Lightblue);
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 8px 8px;
    font-size: 15px;
    color: #FF6603;
    margin-right: 10px;
    margin-bottom: 10px;
}

.novel_create8_1 img {
    width: 18px;
    height: 18px;
    margin-left: 5px;
}

.novel_create9 {
    display: flex;
    align-items: center;
    font-size: 15px;
    color: #FF6603;
    padding: 5px 0;
    margin-bottom: 10px;
}

.novel_create9 img {
    width: 18px;
    height: 18px;
    margin-right: 5px;
}

.create_novel10 {
    padding-left: 95px;
}

.create_novel11 {
    font-size: 13px;
    color: #548AFF;
    margin-top: 10px;
    margin-bottom: 20px;
}

.create_novel12 {
    width: 625px;
    padding: 13px;
    background-color: #FFEBEB;
    border-radius: 4px;
    font-size: 13px;
    color: #FF3030;
    margin-top: 10px;
}

.create_novel20 {
    display: flex;
    justify-content: flex-end;
    width: 625px;
    border-radius: 4px;
    font-size: 13px;
}

.create_novel13 {
    width: 625px;
    display: flex;
    justify-content: end;
}

.create_novel14 {
    width: 125px;
    height: 42px;
    line-height: 42px;
    text-align: center;
    border-radius: 8px;
    font-size: 15px;
    color: #A4A4A4;
    background: #EEEEEE;
    margin-top: 10px;
    cursor: no-drop;
}

.create_novel15 {
    color: #FFF;
    background: #FF8802;
    cursor: default;
}

.create_novel15:hover {
    background-color: #FF6603;
}

.create_novel16 {
    position: absolute;
    right: -150px;
    top: 0;
    /* width: 58px;
    height: 25px; */
    width: 85px;
    height: 32px;
    background: url('../assets/image/icon_create1.png') no-repeat;
    background-size: 100% 100%;
}

.create_novel16:hover {
    background: url('../assets/image/icon_create2.png') no-repeat;
    background-size: 100% 100%;
}

.create_novel30 {
    position: relative;
}

.loading_text_create {
    position: absolute;
    right: -178px;
    top: 3px;
    width: 19px;
    height: 19px;
}

.loading_text_create img {
    width: 100%;
    height: 100%;
    animation: rotate 1s linear infinite;
}

/* 定义旋转动画 */
@keyframes rotate {
    from {
        transform: rotate(0deg);
    }

    to {
        transform: rotate(360deg);
    }
}

.lgText {
    padding: 10px 0;
    margin-left: 170px;
    color: #FF8802;
}

.lgText a {
    color: #FF6603;
    text-decoration: underline;
}
</style>